const config = require("./config")

exports.configure = function configure(options) {
  this.client = config
  if (options.td) {
    Object.keys(options.td).forEach(k => {
      if (options.td[k]) {
        this.client.td[k] = options.td[k]
      }
    })
  }
  if (options.db) {
    Object.keys(options.db).forEach(k => {
      if (options.db[k]) {
        this.client.db[k] = options.db[k]
      }
    })
  }
  if (options.cmp) {
    Object.keys(options.cmp).forEach(k => {
      if (options.cmp[k]) {
        this.client.cmp[k] = options.cmp[k]
      }
    })
  }
  return this.client
}

exports.set = function set(key, value) {
  this.client[key] = value
}

exports.get = function get(key) {
  return this.client[key]
}
